export const environment = {
    clearLocalStorageKey: '1222',
    clearDatabaseKey: '1222',
    isOnline: true,
    version: '1.0.44',
    production: true, // should be true always
    verifyAuth: true, // should be true always
    debug: false, // should be false always
    powerOfOneEnabled: false,
    databaseName: 'uat_route_runner_app',
    domain: 'https://uat.backend.routerunner.co.za/api/mobile/v1',
    sentry: {
        enabled: true,
        dsn: 'https://a2b3ecb147ba6db3b58d4c0b0f8e13d3@o4511070273273856.ingest.de.sentry.io/4511070330093648',
        appName: 'uat-route-runner-app',
    },
    reverb: {
        broadcaster: 'reverb',
        key: 'dm2hwf38lihjpl1g0vdc',
        wsHost: 'ws.uat.backend.routerunner.co.za',
        wsPort: 8080,
        wssPort: 443,
        forceTLS: true,
        enabledTransports: ['ws', 'wss'],
        disableStats: true,
        authEndpoint: 'https://uat.backend.routerunner.co.za/broadcasting/auth',
    },
};
